import React from "react";
import { Recycle, ArrowRight } from "lucide-react";
import copperscrap from "../Images/copperscrap.png";
import almuniumscrap from "../Images/almuniumscrap.png";
import IronRod from "../Images/Iron rod.png";
import { useNavigate } from "react-router-dom";
import SEO from "../Components/SEO";

const Services = () => {
  const navigate=useNavigate();
  const services = [
    {
      title: "Copper Millberry Scrap Supplier",
      image:copperscrap,
      description:
        "We are a trusted supplier of high-quality Copper Millberry Scrap, offering bulk quantities for recycling industries, manufacturers, and industrial buyers at competitive market prices.",
    },
    {
      title: "Premium Aluminium Wire Scrap Supplier",
      image:
        almuniumscrap,
      description:
        "We supply premium-grade Aluminium Wire Scrap in bulk quantities with assured quality, transparent pricing, and reliable delivery solutions across India.",
    },
    {
      title: "Iron Punching Scrap Supplier",
      image:
        IronRod,
      description:
        "Bulk supplier of Iron Punching Scrap suitable for recycling and manufacturing industries. We provide consistent quality materials with timely dispatch services.",
    },
  ];

  return (
    <>
      <SEO 
        title="Industrial Metal & Scrap Supply Services" 
        description="We are premium bulk suppliers of Copper Millberry scrap, Aluminium wire scrap, and Iron punching scrap with assured quality and timely dispatch."
        keywords="industrial metal supply, scrap supply services, copper millberry scrap, aluminium wire scrap bulk, iron punching scrap supplier"
      />
   <style>{`
.services-section{
  padding:80px 5%;
  background:linear-gradient(135deg,#f8fafc,#eef4ff);
  overflow:hidden;
}

/* =========================
   HEADING
========================= */

.section-title{
  text-align:center;
  font-size:42px;
  font-weight:700;
  color:#0B2E7A;
  margin-bottom:20px;
  display:flex;
  flex-direction:column;
  align-items:center;
  animation:fadeDown 1s ease;
}

.title-line{
  width:80px;
  height:4px;
  background:#FFD400;
  margin-top:12px;
  border-radius:10px;
  transition:.4s;
}

.section-title:hover .title-line{
  width:180px;
}

.section-subtitle{
  text-align:center;
  color:#666;
  max-width:800px;
  margin:auto;
  margin-bottom:60px;
  line-height:1.8;
  font-size:16px;
}

/* =========================
   GRID
========================= */

.services-grid{
  display:grid;
  grid-template-columns:repeat(3,1fr);
  gap:30px;
  max-width:1300px;
  margin:auto;
}

/* =========================
   CARD
========================= */

.service-card{
  background:#fff;
  border-radius:20px;
  overflow:hidden;
  box-shadow:0 10px 30px rgba(0,0,0,.08);
  transition:.4s;
  display:flex;
  flex-direction:column;
  height:100%;
}

.service-card:hover{
  transform:translateY(-12px) scale(1.02);
  box-shadow:0 25px 50px rgba(11,46,122,.18);
}

.service-image{
  height:250px;
  overflow:hidden;
}

.service-image img{
  width:100%;
  height:100%;
  object-fit:cover;
  transition:.7s;
}

.service-card:hover .service-image img{
  transform:scale(1.12);
}

/* =========================
   CONTENT
========================= */

.service-content{
  padding:25px;
  display:flex;
  flex-direction:column;
  flex:1;
}

.service-icon{
  width:60px;
  height:60px;
  border-radius:50%;
  background:#FFD400;
  color:#0B2E7A;
  display:flex;
  align-items:center;
  justify-content:center;
  margin-top:-55px;
  position:relative;
  z-index:2;
  box-shadow:0 10px 20px rgba(255,212,0,.4);
  transition:.4s;
}

.service-card:hover .service-icon{
  transform:rotate(360deg);
}

.service-title{
  font-size:22px;
  font-weight:700;
  color:#0B2E7A;
  margin:18px 0 15px;
  min-height:60px;
  line-height:1.4;
}

.service-description{
  color:#666;
  line-height:1.8;
  font-size:15px;
  flex:1;
}

/* =========================
   BUTTON
========================= */

.service-btn{
  margin-top:25px;
  display:flex;
  align-items:center;
  justify-content:center;
  gap:8px;
  width:150px;
  align-self:center;
  padding:12px 16px;
  background:#0B2E7A;
  color:#fff;
  border-radius:8px;
  text-decoration:none;
  font-weight:600;
  font-size:14px;
  cursor:pointer;
  transition:.35s;
}

.service-btn:hover{
  background:#FFD400;
  color:#0B2E7A;
  transform:translateY(-3px);
  box-shadow:0 10px 20px rgba(255,212,0,.35);
}

.service-btn:active{
  transform:scale(1.06);
}

/* =========================
   ANIMATION
========================= */

@keyframes fadeDown{

  from{
    opacity:0;
    transform:translateY(-30px);
  }

  to{
    opacity:1;
    transform:translateY(0);
  }

}

/* =========================
   TABLET
========================= */

@media (max-width:992px){

  .services-section{
    padding:70px 20px;
  }

  .section-title{
    font-size:36px;
  }

  .section-subtitle{
    font-size:15px;
    margin-bottom:45px;
  }

  .services-grid{
    grid-template-columns:repeat(2,1fr);
    gap:25px;
  }

  .service-image{
    height:220px;
  }

  .service-title{
    font-size:20px;
    min-height:auto;
  }

}

/* =========================
   MOBILE
========================= */

@media (max-width:768px){

  .services-section{
    padding:55px 15px;
  }

  .section-title{
    font-size:30px;
  }

  .title-line{
    width:70px;
  }

  .section-title:hover .title-line{
    width:120px;
  }

  .section-subtitle{
    font-size:14px;
    line-height:1.7;
    margin-bottom:35px;
  }

  .services-grid{
    grid-template-columns:1fr;
    gap:22px;
  }

  .service-image{
    height:220px;
  }

  .service-content{
    padding:20px;
  }

  .service-icon{
    width:55px;
    height:55px;
    margin-top:-45px;
  }

  .service-title{
    font-size:19px;
    margin:15px 0 12px;
  }

  .service-description{
    font-size:14px;
    line-height:1.7;
  }

  .service-btn{
    width:100%;
    padding:13px;
    font-size:15px;
  }

}

/* =========================
   SMALL MOBILE
========================= */

@media (max-width:480px){

  .services-section{
    padding:45px 12px;
  }

  .section-title{
    font-size:26px;
  }

  .service-image{
    height:200px;
  }

  .service-content{
    padding:18px;
  }

  .service-icon{
    width:50px;
    height:50px;
  }

  .service-title{
    font-size:17px;
  }

  .service-description{
    font-size:13px;
  }

  .service-btn{
    font-size:14px;
    padding:12px;
  }

}
`}</style>

      <section className="services-section">
        <h2 className="section-title">
          Our Services
          <span className="title-line"></span>
        </h2>

        <p className="section-subtitle">
          We specialize in bulk + buying and selling of premium industrial scrap
          materials with competitive pricing, reliable logistics, and trusted
          business relationships across India.
        </p>

        <div className="services-grid">
          {services.map((service, index) => (
            <div className="service-card" key={index}>
              <div className="service-image">
                <img src={service.image} alt={service.title} />
              </div>

              <div className="service-content">
                <div className="service-icon">
                  <Recycle size={28} />
                </div>

                <h3 className="service-title">{service.title}</h3>

                <p className="service-description">
                  {service.description}
                </p>

                <p onClick={()=>navigate('/contact')} className="service-btn">
                  Get Quote <ArrowRight size={16} />
                </p>
              </div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default Services;